exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "header[data-v-ac7b3d92]{position:fixed;z-index:5;-webkit-transform:translate(-50%);transform:translate(-50%);left:50%;width:40px;height:56px;top:20px}header.isLarge[data-v-ac7b3d92]{width:360px;top:60px}header a[data-v-ac7b3d92]{width:100%;height:100%;display:block}header a span[data-v-ac7b3d92]{position:absolute;left:-50000px}header a svg[data-v-ac7b3d92]{width:100%;height:100%;display:block}", ""]);

// exports
